import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  AuthService,
  WorkspaceService,
  type AuthUser,
} from '@principle-theorem/ng-auth';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import {
  ManagementService,
  PartnerService,
} from '@principle-theorem/ng-principle-shared';
import {
  NgSharedModule,
  ProfileImageService,
} from '@principle-theorem/ng-shared';
import {
  WorkspaceType,
  type IUser,
} from '@principle-theorem/principle-core/interfaces';
import { multiFilter } from '@principle-theorem/shared';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthUserCardComponent } from '../../auth/auth-user-card/auth-user-card.component';

@Component({
  selector: 'pr-partner-toolbar-dropdown',
  templateUrl: './partner-toolbar-dropdown.component.html',
  styleUrls: ['./partner-toolbar-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    NgMaterialModule,
    NgSharedModule,
    AuthUserCardComponent,
  ],
})
export class PartnerToolbarDropdownComponent {
  profileImage = inject(ProfileImageService);
  authUser$: Observable<AuthUser>;
  user$: Observable<IUser | undefined>;
  hasWorkspaces$: Observable<boolean>;
  isManagementUser$: Observable<boolean>;
  readonly iconSize: number = 36;

  constructor(
    public auth: AuthService,
    public partner: PartnerService,
    management: ManagementService,
    public workspace: WorkspaceService,
    private _router: Router
  ) {
    this.user$ = this.partner.user$;
    this.hasWorkspaces$ = workspace.workspaces$.pipe(
      multiFilter(
        (workspaces) => workspaces.type === String(WorkspaceType.Partner)
      ),
      map((workspaces) => workspaces.length > 1)
    );
    this.isManagementUser$ = management.user$.pipe(map((user) => !!user));
  }

  async changeWorkspace(): Promise<void> {
    await this._router.navigate(['/', 'workspaces']);
  }
}
